import React from 'react';
// It is safe to use this package here, because it is available in the new
// consumer app, and in the old package a mock is used.
// eslint-disable-next-line import/no-unresolved
import useCarouselFix from 'use-carousel-fix';
import IconArrowLeftWhite from 'components/icons/Slider/iconArrowLeftWhite';
import IconArrowRightWhite from 'components/icons/Slider/iconArrowRightWhite';

function cls(...classes) {
  return classes.filter(Boolean).join(' ');
}

const CustomCarouselArrows = () => {
  const {
    currentPage,
    totalPages,
    wrapMode,
    goBack,
    goForward,
  } = useCarouselFix();

  const allowWrap = wrapMode === 'wrap';
  const enablePrevNavButton = allowWrap || currentPage > 0;
  const enableNextNavButton = allowWrap || currentPage < totalPages - 1;

  const prevNavClassName = cls(
    'relative w-[50px] h-[50px] rounded-[100px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 [transition:all_.2s_ease-in] hover:border-brand !bg-white',
    '[&_svg_path]:[transition:all_.2s_ease-in] [&_svg_path]:fill-gray',
    'group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]',
    enablePrevNavButton && '!visible'
  );

  const nextNavClassName = cls(
    'relative right-2.5 w-[50px] h-[50px] rounded-[100px] !flex justify-center items-center opacity-100 text-[0] leading-[0] cursor-pointer text-transparent border border-solid border-gray-light6 outline-0 [transition:all_.2s_ease-in] hover:border-brand !bg-white',
    '[&_svg_path]:[transition:all_.2s_ease-in] [&_svg_path]:fill-gray',
    'group-hover/SliderButton:[&_svg_path]:fill-[#2f2f2e]',
    enableNextNavButton && '!visible'
  );

  return (
    <div className="absolute w-full flex justify-between -translate-y-[630%]">
      <button type="button" className={prevNavClassName} onClick={goBack}>
        <IconArrowLeftWhite />
      </button>
      <button type="button" className={nextNavClassName} onClick={goForward}>
        <IconArrowRightWhite />
      </button>
    </div>
  );
};

export default CustomCarouselArrows;
